module.exports = __webpack_public_path__ + "static/media/favicon.49c5b16f.ico";